import { ModalRoot } from '@cian/ui-kit';
import { ArticleParagraph1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { getTermsValue } from '../../../../packages/JsonQuery';
import { ETestId } from '../../../common/constants';
import { Chip } from '../../components/RedesignedFilters';
import { useChip } from '../../hooks/useChip';
import { getStarRatingLabel } from '../../utils/getStarRatingLabel';
import { StarRatingModalContainer } from '../StarRatingModalContainer';

export const StarRatingChipContainer = () => {
  const { jsonQuery } = useFiltersContext();
  const { open, onChipClick, onReset, onCloseWithReset, onApplyClick } = useChip(['star_rating']);

  const defaultLabel = 'Количество звёзд';
  const starRating = getTermsValue('star_rating')(jsonQuery);
  const label = getStarRatingLabel(starRating);

  return (
    <ModalRoot open={open} onOpenChange={onCloseWithReset}>
      <Chip onClick={onChipClick} testId={ETestId.RedesignedFiltersStarRatingChip}>
        <ArticleParagraph1>{label || defaultLabel}</ArticleParagraph1>
      </Chip>
      <StarRatingModalContainer onClose={onCloseWithReset} onResetClick={onReset} onApplyClick={onApplyClick} />
    </ModalRoot>
  );
};
